import palette from '../layout/ColorPalette';

const SCORE_COLORS = [palette.score.red, palette.score.yellow, palette.score.green];

/** One of the three score colors (red / yellow / green) from the numeric score. */
export const getScoreColor = (score: number) => {
    return SCORE_COLORS[Math.min(Math.floor(score / 33.4), 2)];
};
